const merge = require('webpack-merge')

let config = {
  TOKEN_KEY: "stoken"
}

const customName = process.env.CONF_CUSTOM

const customConfig = {
  // 安徽省合肥市庐州公证处
  lz:{
    baseURL: 'https://hflzgzc.houmagongzheng.cn/web',
    ebqAccount:'https://jzqa.jxsncxgzc.com',
    NOTAR_WBQ: 'https://wbq.jxsncxgzc.com',//公证取证
    NOTAR_JZQ: 'https://jzq.jxsncxgzc.com',//公证电子签
    CUSTOM_TEST:'安徽省合肥市庐州公证处',
  },
  // 江苏省南京市石城公证处
  sc:{
    baseURL: 'https://njscgzc.houmagongzheng.cn/web',
    ebqAccount:'https://jzqa.jxsncxgzc.com',
    NOTAR_WBQ: 'https://wbq.jxsncxgzc.com',//公证取证
    NOTAR_JZQ: 'https://jzq.jxsncxgzc.com',//公证电子签
    CUSTOM_TEST:'江苏省南京市石城公证处',
  },
  // 咸阳市公证处
  xy:{
    baseURL: 'https://xygzc.houmagongzheng.cn/web',
    ebqAccount:'https://jzqa.jxsncxgzc.com',
    NOTAR_WBQ: 'https://wbq.jxsncxgzc.com',//公证取证
    NOTAR_JZQ: 'https://jzq.jxsncxgzc.com',//公证电子签
    CUSTOM_TEST:'咸阳市公证处',
  },
  // 内蒙古自治区包头市方正公证处
  fz:{
    baseURL: 'https://btfzgzc.houmagongzheng.cn/web',
    ebqAccount:'https://jzqa.jxsncxgzc.com',
    NOTAR_WBQ: 'https://wbq.jxsncxgzc.com',//公证取证
    NOTAR_JZQ: 'https://jzq.jxsncxgzc.com',//公证电子签
    CUSTOM_TEST:'安徽省合肥市庐州公证处',
  },
  // 山西省侯马市公证处
  hm:{
    baseURL: 'https://hmgzc.houmagongzheng.cn/web',
    ebqAccount:'https://jzqa.jxsncxgzc.com',
    NOTAR_WBQ: 'https://wbq.jxsncxgzc.com',//公证取证
    NOTAR_JZQ: 'https://jzq.jxsncxgzc.com',//公证电子签
    CUSTOM_TEST:'山西省侯马市公证处',
  },
  // 山东省临沂市东信公证处
  dx:{
    baseURL: 'https://dxgzc.wbq360.com/web',
    ebqAccount:'',
    NOTAR_WBQ: '',//公证取证
    NOTAR_JZQ: '',//公证电子签
    CUSTOM_TEST:'山东省临沂市东信公证处',
  },
};

console.log(33333333333,process.env.CONF_CUSTOM,customConfig['ys'])


if (process.env.CONF_ENV === 'production') {
  if(customName !== 'undefined' && customConfig[customName]){
    config = merge(config,{
      domain:customConfig[customName]
    });
  }else{
    config = merge(config, {
      domain: {
        baseURL: 'https://whzcgz.ebaoquan.com/web',
        ebqAccount:'https://jzqa.jxsncxgzc.com',
        NOTAR_WBQ: 'https://wbq.jxsncxgzc.com',//公证取证
        NOTAR_JZQ: 'https://jzq.jxsncxgzc.com'//公证电子签
      }
    });
  }

} else if (process.env.CONF_ENV === 'sandbox') {
  config = merge(config, {
    domain: {
      baseURL: 'http://nxfqgz.demo.ebq.bz/web',
      ebqAccount:'http://account.demo.ebq.bz',
      mobile_front_url:"http://nxfqgz.demo.ebq.bz/m",
      video_front_url: 'https://rtc-sandbox.ebaoquan.com',
      VIDEO_SERVER_API: 'http://nxfqgz.demo.ebq.bz/video',
      NOTAR_WBQ: 'http://wbq.demo.ebq.bz',//公证取证
      NOTAR_JZQ: 'http://jzq.demo.ebq.bz',//公证电子签
      SMART_NOTAR_WEB_URL:'http://nxfqgz.demo.ebq.bz/smart'
    }
  });
} else {
  config = merge(config, {
    domain: {
      // baseURL:'https://whzcgz.ebaoquan.com/web',
      baseURL: 'http://nxfqgz.demo.ebq.bz/web',
      // baseURL: 'http://whzc.demo.ebq.bz/web',
      // baseURL: 'http://192.168.169.119:9001/web',
      // baseURL: 'http://192.168.169.101:9001/web',
      ebqAccount: 'https://jzqa.jxsncxgzc.com',
      mobile_front_url: "http://nxfqgz.demo.ebq.bz/m",
      video_front_url: 'https://rtc-sandbox.ebaoquan.com',
      // VIDEO_SERVER_API: 'http://192.168.169.22:9003/video',
      VIDEO_SERVER_API: 'http://nxfqgz.demo.ebq.bz/video',
      NOTAR_WBQ: 'https://wbq.jxsncxgzc.com',//公证取证
      NOTAR_JZQ: 'https://jzq.jxsncxgzc.com'//公证电子签
    }
  });
}
export default config



// WEBPACK FOOTER //
// ./src/config/index.js